export default __webpack_public_path__ + "static/meaningImg-4ca8ebc1b3d6745f7467822102865d77.png";